import { useTheme } from "../../styles/theme";
import { useApp } from "../../context/AppContext";
import { dispDate } from "../../utils/dates";
import { fmt } from "../../utils/format";
import SectionTitle from "../../components/SectionTitle";
import Field from "../../components/Field";

export default function Purchases() {
  const S = useTheme();
  const {
    data, form, setForm, TODAY,
    addPurchase, markVendorPaid, del,
  } = useApp();

  return (
    <div>
      <SectionTitle>Vendor Purchases — 1-Day Credit</SectionTitle>
      <p style={S.tabDesc}>
        Buy today, pay tomorrow. Payment due date is auto-set to the next day.
      </p>

      {/* Add form */}
      <div style={S.formCard}>
        <div style={S.formGrid}>
          <Field label="Vendor Name">
            <input style={S.input} placeholder="e.g. Raju Traders"
              value={form.vendor || ""}
              onChange={e => setForm({ ...form, vendor: e.target.value })} />
          </Field>
          <Field label="Item / Description">
            <input style={S.input} placeholder="What was purchased?"
              value={form.item || ""}
              onChange={e => setForm({ ...form, item: e.target.value })} />
          </Field>
          <Field label="Amount (₹)">
            <input style={S.input} type="number" placeholder="0"
              value={form.amount || ""}
              onChange={e => setForm({ ...form, amount: e.target.value })} />
          </Field>
          <Field label="Purchase Date">
            <input style={S.input} type="date"
              value={form.purchaseDate || TODAY}
              onChange={e => setForm({ ...form, purchaseDate: e.target.value })} />
          </Field>
        </div>
        <div style={S.creditNote}>📅 Payment auto-due on <strong>next day</strong></div>
        <button style={S.submitBtn} onClick={addPurchase}>+ Add Purchase</button>
      </div>

      {/* History table */}
      <SectionTitle style={{ marginTop: 24 }}>Purchase History</SectionTitle>
      <div style={S.tableWrap}>
        <table style={S.table}>
          <thead>
            <tr>
              {["Vendor","Item","Amount","Purchased","Pay Due","Status","Action"].map(h => (
                <th key={h} style={S.th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.purchases.length === 0 && (
              <tr><td colSpan={7} style={S.emptyCell}>No purchases yet.</td></tr>
            )}
            {data.purchases.map(p => (
              <tr key={p.id} style={S.tr}>
                <td style={S.td}>{p.vendor}</td>
                <td style={S.td}>{p.item || "—"}</td>
                <td style={{ ...S.td, fontWeight: 700, color: S.colors.warn }}>{fmt(p.amount)}</td>
                <td style={S.td}>{dispDate(p.purchaseDate)}</td>
                <td style={S.td}>{dispDate(p.payDue)}</td>
                <td style={S.td}>
                  {p.paid
                    ? <span style={S.badgePaid}>✓ Paid</span>
                    : p.payDue <= TODAY
                      ? <span style={S.badgeDue}>⚠ Due</span>
                      : <span style={S.badgePending}>⏳ Upcoming</span>}
                </td>
                <td style={S.td}>
                  {!p.paid && (
                    <button style={S.smallBtn} onClick={() => markVendorPaid(p.id)}>Pay</button>
                  )}
                  <button style={{ ...S.smallBtn, ...S.deleteBtn }}
                    onClick={() => del("purchases", p.id)}>✕</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
